import {Storage, EventBus} from '../Utils'

export default {
    data() {
        return {
            index: null,
            currentStep: 0,
            lastStep: 0
        }
    },
    mounted() {
        this.setInitialData()
    },
    methods: {
        setInitialData() {
            this.index = this.$route.params.index
            this.currentStep = this.getCurrentStep()
            this.lastStep = this.getLastStep()
        },
        getLastStep() {
            const project = Storage.getProject(this.$route.params.index)
            return project.lastStep
        },
        getCurrentStep() {
            if (this.$route.meta.pageNumber) {
                // assuming pageNumber always has format: [page] of [total]
                const [page, ,] = this.$route.meta.pageNumber.split(' ')
                if (page) {
                    const pageNumber = Number.parseInt(page)
                    if (!Number.isNaN(pageNumber)) {
                        return pageNumber
                    }
                }
            }
            return 0
        }
    },
    watch: {
        $route(to, from) {
            this.setInitialData()
        }
    }
};